<template>
    <div v-if="localRoom">
        <el-form class="main-room-form">
            <el-input placeholder="Enter Room Name" :disabled="room && !localRoom.parent" v-model="localRoom.name" class="input input-name" @change="updateRoom"></el-input>
            <el-input placeholder="Enter Topic Name" v-model="localRoom.topic" class="input input-topic" @change="updateRoom"></el-input>
        </el-form>
        <div class="main-room-responsive">
            <div>
                <div class="mobile-room-name">{{localRoom.name}}</div>
                <div class="topic-name">{{localRoom.topic}}</div>
            </div>
            <div class="mobile-timer" v-if="!restrictControlsForAnonymousUsers">
                <TimerClock v-if="this.mainRoomTimer" :timer="this.mainRoomTimer" />
            </div>
        </div>
    </div>
</template>

<script>
import axios from '../../client';
import {
    mapState
} from 'vuex';
import TimerClock from "../timer/TimerClock";


export default {
    name: "Topic",
     components: {
        TimerClock
    },
    data: function () {
        return{
            localRoom: null,
        }
    },
    mounted() {
        this.localRoom = JSON.parse(JSON.stringify(this.room)) // deepcopy hack
    },
    methods: {
        async updateRoom(){
            try{
                await axios.put('/api/rooms/' + this.localRoom._id, this.localRoom)
            }catch{
                this.$message({
                    dangerouslyUseHTMLString: true,
                    message: `Failed to save room <strong> ${this.localRoom.name}</strong>. <br> Please check and try again`,
                    type: "error",
                    showClose: true
                })
            }
        },
    },
     watch: {
        room: {
            handler: function(newVal) {
                this.localRoom = JSON.parse(JSON.stringify(newVal))
            },
            deep: true
        }
    },
    computed: {
        ...mapState({
            allRooms: state => state.rooms.rooms,
            room: state => state.rooms.currentRoom,
            restrictControlsForAnonymousUsers: state => state.mainRoomConfig.currentRoom.restrictControlsForAnonymousUsers && !state.user.profile.loggedIn,
        }),
        mainRoomTimer: function(){
            const mainRoom = this.allRooms.find(room => !room.parent)
            return mainRoom && mainRoom.timer
        }
    }
}
</script>

<style scoped>
.main-room-form {
    display: flex;
    width: 100%;
}
.main-room-responsive {
    display: none;
    text-align: left;
}
.topic-name, .mobile-room-name{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: calc(100vw - 200px);

}
.topic-name{
    font-size: 12px;
}
@media (max-width: 767px){
    .main-room-form {
        display: none;
    }
    .main-room-responsive {
        display: inline-flex;
        margin-left: 8px;
    }
}

@media (hover: none) {
    .main-room-form {
        display: none;
    }
    .main-room-responsive {
        display: inline-flex;
        margin-left: 8px;
    }
}

>>>.el-input__inner,
>>>.el-input.is-disabled .el-input__inner {
    height: 32px;
    line-height: 32px;
    background-color: #393752;
    border: 1px solid #393752;
    border-radius: 3px;
    color: #E7E6FA;
    font-size: 16px;
}
.input-topic >>>.el-input__inner{
    font-size: 16px;
}
.input {
    margin-left: 8px;
}
.input-name {
   width: 40%;
}
.input-topic {
    width: 60%;
    font-size: 12px;
}
.mobile-timer{
    margin-left: 35px;
    display: flex;
    align-items: center;
}
</style>
